var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticStyle:{"position":"relative","user-select":"none","overflow":"hidden","touch-action":"none"},attrs:{"id":"container"}},[_vm._t("default",null,null,{ selected: _vm.intersected })],2)}
var staticRenderFns = []

export { render, staticRenderFns }